module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_8_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_8_after_tn.jpg
// module id = 1675
// module chunks = 0